import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs';
import { openConfirmationDialog } from '../components/confirmation-popup/confirmation-popup';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

// Generic CanDeactivate guard: prompts before leaving a route whose component reports pending
// edits. No existing precedent for this in the codebase (every other "detail" screen is a
// MatDialog, closed without any unsaved-changes check) — this is the first route-level one,
// built for the Organisations detail screen (DEV-1192 AC #8), reusable by any future routed
// component that implements HasUnsavedChanges.
export const confirmUnsavedChanges: CanDeactivateFn<HasUnsavedChanges> = component => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  const matDialog = inject(MatDialog);
  return openConfirmationDialog(matDialog, {
    title: 'Discard changes?',
    message: 'This organisation has unsaved changes. Leaving now will discard them.'
  })
    .afterClosed()
    .pipe(map(result => result === 'Confirmed'));
};
